<template>
  <div class="wrap">
    <div class="headers">
      <div class="logo">
        <a href="https://bluexad.ai/" target="_blank">
          <img src="../../assets/img/logo_col.png">
          <span class="logo-text">| {{$t("login.logoDevPlatform")}}</span>
        </a>
      </div>
      <div class="left_bottom_text_plain">
        <p>{{$t("login.abroadCooperation")}}</p>
      </div>
    </div>

    <div class="header-right">
      <div class="header-user-con">
        <el-dropdown trigger="click" @command="langChange">
          <span class="el-dropdown-link">
            {{language}} <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided  command="zh">中文</el-dropdown-item>
            <el-dropdown-item divided  command="en">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="ms-login">
      <div v-if="currentPage === 'register'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ms-content" size="large">
          <el-row class="ms-title">
            <el-col :span="24">
              <p class="user-behavior">{{$t('login.welcomeSignup')}}</p>
              <p class="devPlatform">{{$t('login.devPlatform')}}</p>
            </el-col>
          </el-row>
          <el-form-item label :error="emailErrMsg" prop="email">
            <el-input
              v-model.trim="ruleForm.email"
              :placeholder="$t('forget.Email')"
              prefix-icon="el-icon-message"
            ></el-input>
          </el-form-item>
          <el-form-item label prop="password">
            <el-input
              type="password"
              show-password
              v-model.trim="ruleForm.password"
              prefix-icon="el-icon-lock"
              :placeholder="$t('login.setPwd')"
            ></el-input>
          </el-form-item>
          <el-form-item label prop="confirm_password">
            <el-input
              type="password"
              show-password
              v-model.trim="ruleForm.confirm_password"
              prefix-icon="el-icon-lock"
              :placeholder="$t('login.confirmPwd')"
            ></el-input>
          </el-form-item>
          <el-form-item label :error="phoneErrMsg" prop="mobile_phone">
            <el-input
              :placeholder="$t('forget.tel')"
              v-model.trim="ruleForm.mobile_phone"
              prefix-icon="el-icon-mobile"
              @input="handleInputValidation">
              <template slot="prepend">
                <el-select 
                  v-model="ruleForm.itu_code" 
                  style="width: 100px"
                >
                  <el-option
                    v-for="item in ituList"
                    :key="item.value"
                    :label="`${item.value}`"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item class="captcha" label :error="captchaErrMsg" prop="captcha">
            <el-input
              v-model.trim="ruleForm.captcha"
              @input="handleInputValidation"
              prefix-icon="el-icon-check"
              :placeholder="$t('login.imgCode')"
            ></el-input>
            <div class="captcha-img">
              <img :src="captchaUrl" />
              <div @click="handleCaptcha" class="cover"></div>
            </div>
          </el-form-item>
          <el-form-item class="send-code-info" label prop="sms_code">
            <el-input
              v-model.trim="ruleForm.sms_code"
              prefix-icon="el-icon-chat-line-square"
              :placeholder="$t('forget.msgCode')"
            ></el-input>
            <el-button
              class="send-code-btn"
              @click="handleSendCode"
              :disabled="showSendCodeBtn"
              type="primary"
            >{{ sendCodeBtnName }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="submit-button" type="primary" @click="submitForm('ruleForm')">{{$t('login.regist')}}</el-button>
          </el-form-item>
          <el-form-item>
            <p class="toLogin" @click="handleLogin">{{$t('login.toLogin')}}</p>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="currentPage === 'companyInfo'">
        <el-form :model="companyInfoForm" :rules="companyInfoRules" ref="companyInfoForm" class="ms-content" size="large">
          <el-row class="ms-title">
            <el-col :span="24">
              <p class="title">{{$t('login.companyInfo')}}</p>
              <p class="companyInfo">{{$t('login.companyInfoUse')}}</p>
            </el-col>
          </el-row>
          <el-form-item label prop="companyName">
            <el-input
              v-model.trim="companyInfoForm.companyName"
              :placeholder="$t('companyInfo.companyName')"
            ></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label prop="brandNameEN">
                <el-input
                  v-model.trim="companyInfoForm.brandNameEN"
                  :placeholder="$t('companyInfo.brandNameEN')"
                ></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <el-form-item label prop="brandNameCN">
                <el-input
                  v-model.trim="companyInfoForm.brandNameCN"
                  :placeholder="$t('companyInfo.brandNameCN')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label prop="country">
                <el-select 
                  v-model="companyInfoForm.country" 
                  clearable
                  filterable
                  :placeholder="$t('companyInfo.country')"
                >
                  <el-option
                    v-for="item in countryList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <el-form-item label prop="industry">
                <el-select 
                  v-model="companyInfoForm.industry" 
                  clearable
                  filterable
                  :placeholder="$t('companyInfo.industry')"
                >
                  <el-option
                    v-for="item in industryList"
                    :key="item.value"
                    :label="$i18n.locale === 'zh' ? item.labelZh : item.labelEn"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label prop="websiteURL">
            <el-input
              v-model.trim="companyInfoForm.websiteURL"
              :placeholder="$t('companyInfo.websiteURL')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="submit-button" type="primary" @click="submitCompanyInfo('companyInfoForm')">{{$t('login.companyInfoLogin')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/utils/util'
import perm from '@/utils/permission'
const DOMAIN_CONFIG = require('@/utils/domainConfig')
export default {
  data() {
    return {
      currentPage: "register",
      captchaUrl: "",
      showSendCodeBtn: true,
      sendCodeBtnName: "获取验证码",
      timer: null,
      emailErrMsg: "",
      captchaErrMsg: "",
      phoneErrMsg: "",
      ruleForm: {
        email: "",
        password: "",
        confirm_password: "",
        mobile_phone: "",
        sms_code: "",
        area: 2,
        itu_code: "+86",
        captcha: ""
      },
      language: '中文',
      ituList: [
        { value: "+86",label: "CHN"},
        { value: "+852",label: "HKG"},
        { value: "+853",label: "MAC"},
        { value: "+886",label: "TWN"},
        { value: "+1",label: "USA/CAN"},
        { value: "+7",label: "RUS"},
        { value: "+48",label: "POL"},
        { value: "+60",label: "MYS"},
        { value: "+62",label: "IDN"},
        { value: "+65",label: "SGP"},
        { value: "+84",label: "VNM"},
        { value: "+357",label: "CYP"},
        { value: "+375",label: "BLR"}
      ],
      companyInfoForm: {
        companyName: "",
        brandNameEN: "",
        brandNameCN: "",
        country: "",
        industry: "",
        websiteURL: "",
      },
      countryList: [],
      industryList: [
        { value: 'Gaming', labelZh: '游戏', labelEn: 'Gaming' },
        { value: 'Tools / Utilities', labelZh: '工具类', labelEn: 'Tools / Utilities' },
        { value: 'Entertainment', labelZh: '娱乐类', labelEn: 'Entertainment' },
        { value: 'Social', labelZh: '社交', labelEn: 'Social' },
        { value: 'Education', labelZh: '教育', labelEn: 'Education' },
        { value: 'Lifestyle', labelZh: '生活方式', labelEn: 'Lifestyle' },
        { value: 'Productivity', labelZh: '效率类', labelEn: 'Productivity' },
        { value: 'Music / Audio', labelZh: '音乐/音频', labelEn: 'Music / Audio' },
        { value: 'Finance', labelZh: '金融/投资', labelEn: 'Finance' },
        { value: 'Health & Fitness', labelZh: '健康类', labelEn: 'Health / Fitness' },
        { value: 'Shopping / E-commerce', labelZh: '电商', labelEn: 'Shopping / E-commerce' },
        { value: 'Travel', labelZh: '旅游', labelEn: 'Travel' },
        { value: 'News / Media', labelZh: '新闻/资讯类', labelEn: 'News / Media' },
        { value: 'Kids / Family', labelZh: '儿童', labelEn: 'Kids / Family' },
        { value: 'Photography', labelZh: '摄影类', labelEn: 'Photography' },
        { value: 'Business', labelZh: '商务类', labelEn: 'Business' }
      ]
    }
  },
  computed: {
    rules() {
      return {
        email: [
          { validator: this.validateEmail, trigger: "blur" },
          { type: 'email', message: this.$t('login.emailError'), trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: this.$t('login.pwdCheck'), trigger: "blur" },
          { min: 6, message: this.$t('login.min'), trigger: "blur" }
        ],
        confirm_password: [
          { required: true, message: this.$t('login.confirmPwdCheck'), trigger: "blur" },
          { min: 6, message: this.$t('login.min'), trigger: "blur" },
          { 
            validator: this.validateConfirmPassword, 
            trigger: ['blur'] 
          }
        ],
        mobile_phone: [{ validator: this.validatePhone, trigger: "blur" }],
        captcha: [{ required: true, message: this.$t('login.codeCheck'), trigger: "blur" }],
        sms_code: [
          { required: true, message: this.$t('forget.smsCheck'), trigger: "blur" }
        ]
      }
    },
    companyInfoRules() {
      return {
        companyName: [
          { required: true, message: this.$t('companyInfo.companyNameCheck'), trigger: "blur" },
          { 
            validator: (rule, value, callback) => {
              const val = value.trim() || '';
              if (!val) {
                callback();
                return;
              }

              if (/^\d/.test(val) || /\d$/.test(val)) {
                callback(new Error(this.$t('companyInfo.companyNameStartEndCheck')));
                return;
              }
              const utf8Length = new Blob([val]).size;
              if (utf8Length < 2 || utf8Length > 120) {
                callback(new Error(this.$t('companyInfo.companyNameLengthCheck')));
                return;
              }

              const invalidCharReg = /[@#$%&*!?^~'"\\/|{}[\]<>]|[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/u;
              if (invalidCharReg.test(val)) {
                callback(new Error(this.$t('companyInfo.companyNameSpecialCharCheck')));
                return;
              }
              callback();
            },
            trigger: ["blur"] 
          }
        ],  
        
        brandNameEN: [
          { required: true, message: this.$t('companyInfo.brandNameENCheck'), trigger: "blur" },
          { pattern: /^[a-zA-Z]+$/, message: this.$t('companyInfo.brandNameENFormatCheck'), trigger: "blur"},
          { 
            validator: (rule, value, callback) => {
              if (value && value === this.companyInfoForm.companyName) {
                callback(new Error(this.$t('companyInfo.brandNameENUniqueCheck')))
              } else {
                callback()
              }
            },
            trigger: "blur"
          }
        ],
        
        brandNameCN: [
          { pattern: /^[\u4e00-\u9fa5a-zA-Z0-9\s]*$/, message: this.$t('companyInfo.brandNameCNFormatCheck'), trigger: "blur"},
          { 
            validator: (rule, value, callback) => {
              if (!value || value.trim() === '') {
                callback() 
                return
              }
              
              if (!/[\u4e00-\u9fa5]/.test(value)) {
                callback(new Error(this.$t('companyInfo.brandNameCNChineseCheck')))
              } else {
                callback()
              }
            },
            trigger: "blur"
          }
        ],
        
        country: [
          { required: true, message: this.$t('companyInfo.countryCheck'), trigger: "change" }
        ],
        
        industry: [
          { required: true, message: this.$t('companyInfo.industryCheck'), trigger: "change" },
        ],
        
        websiteURL: [
          { 
            pattern: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/,
            message: this.$t('companyInfo.websiteFormatCheck'),
            trigger: "blur"
          }
        ]
      }
    }
  },
  created() {
    var lang = localStorage.getItem("lang")
    if (lang == 'en') {
      this.language = 'English'
      this.$i18n.locale = 'en'
    } else if (lang == 'zh') {
      this.language = '中文'
      this.$i18n.locale = 'zh'
    } else {
      this.language = 'English'
      this.$i18n.locale = 'en'
    }
    
    this.ruleForm.area = 2 
    
    this.sendCodeBtnName = this.$t('forget.getCode')
    this.handleCaptcha()
    this.getCountryList()
  },
  methods: {
    // 语言切换
    langChange(command) {
      this.$i18n.locale = command
      localStorage.setItem("lang", command)
      this.language = command === 'en' ? 'English' : '中文'
      this.sendCodeBtnName = this.$t('forget.getCode')
    },
    // 邮箱验证
    validateEmail(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t('login.emailCheck')))
      } else {
        const params = { email: this.ruleForm.email }
        this.validateEmailPhone(params, callback)
      }
    },
    // 手机号验证
    validatePhone(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t('forget.phoneCheck')))
      } else {
        let reg = /^1[3-9]\d{9}$/
        if (this.ruleForm.area == 2 && this.ruleForm.itu_code != '+86') {
          reg = /^[0-9]{5,16}$/
        }
        if (!reg.test(value)) {
          callback(new Error(this.$t('login.phoneError')))
        } else {
          const params = {
            mobile: this.ruleForm.mobile_phone,
            itu_code: this.ruleForm.itu_code
          }
          this.validateEmailPhone(params, callback)
        }
      }
    },
    // 邮箱-手机号验证接口
    validateEmailPhone(params, callback) {
      this.__postData(
        "registerCheck",
        params,
        res => {
          if (res.code == 1) {
            callback(new Error(res.msg))
          } else {
            callback()
          }
        },
        errmsg => {
          callback(new Error(errmsg))
        }
      )
    },
    // 请再次确认密码
    validateConfirmPassword(rule, value, callback) {
      if (!value) return callback()
      if (value !== this.ruleForm.password) {
        callback(new Error(this.$t('login.pwdNotMatch')))
      } else {
        callback()
      }
    },
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid, data) => {
        if (valid) {
          const params = {
            ...this.ruleForm
          }
          this.__postData("abroadRegiste", params, res => {
            if (res.code == 1) {
              this.$message.error(res.msg)
            } else {
              this.$message.success(this.$t('message.registLogin'))
              util.setCookie("token", res.token)
              util.setCookie("user", util.userCookieValue(res))
              // 注册完直接登录：导航树跟在同一个响应里（新注册的就是主账号）
              perm.saveFromLogin(res)
              this.currentPage = 'companyInfo'
            }
          }, errmsg => {
            this.$message.error(errmsg)
          })
        } else {
          this.$message.error(this.$t('message.completeForm'))
        }
      })
    },
    // 点击去登录
    handleLogin() {
      this.$router.push("/login")
    },
    // 点击获取图形验证码
    handleCaptcha() {
      this.__postData("getCaptcha", {}, res => {
        if (res.code == 1) {
          this.$message.error("图形验证码获取失败")
        } else {
          this.captchaUrl = res.image_data
        }
      }, errmsg => {
        this.$message.error(errmsg)
      })
    },
    // 点击发送短信验证码
    handleSendCode() {
      if (this.timer) return
      
      const params = {
        mobile: this.ruleForm.mobile_phone,
        captcha: this.ruleForm.captcha,
        itu_code: this.ruleForm.itu_code,
        type: 1, // 1注册,2登录,3找回密码
      }
      
      this.__postData("getSms", params, res => {
        if (res.code == 1) {
          this.$message.error(res.msg)
          return
        }
        
        this.$message.success("短信验证码已发送至您手机，请注意查收！")
        let count = 60
        this.sendCodeBtnName = count + "s"
        this.showSendCodeBtn = true
        
        this.timer = setInterval(() => {
          if (count > 0 && count <= 60) {
            count--
            this.sendCodeBtnName = count + "s"
          } else {
            this.showSendCodeBtn = false
            clearInterval(this.timer)
            this.timer = null
            this.sendCodeBtnName = this.$t('forget.getCode')
          }
        }, 1000)
      }, errmsg => {
        this.$message.error(errmsg)
      })
    },
    // 输入验证（控制发送验证码按钮状态）
    handleInputValidation() {
      const isValidCaptcha = this.ruleForm.captcha.length === 4
      const isValidPhone = this.ruleForm.mobile_phone.length >= 5 && this.ruleForm.mobile_phone.length <= 16
      
      this.showSendCodeBtn = !(isValidCaptcha && isValidPhone)
    },
    submitCompanyInfo(companyInfoForm) {
      this.$refs[companyInfoForm].validate((valid, data) => {
        if (valid) {
          const params = {
            email: JSON.parse(util.getCookie("user")).email,
            company_name: this.companyInfoForm.companyName,
            brand_name_en: this.companyInfoForm.brandNameEN,
            brand_name_cn: this.companyInfoForm.brandNameCN,
            country: this.companyInfoForm.country,
            industry: this.companyInfoForm.industry,
            website_url: this.companyInfoForm.websiteURL
          }
          this.__putData("companyInfoRegister", params, res => {
            if (res.code == 1) {
              this.$message.error(res.msg)
            } else {
              this.$message.success(this.$t('message.successSava'))
              const userObj = JSON.parse(util.getCookie('user'))
              userObj.verify_code = res.verify_code
              util.setCookie('user', JSON.stringify(userObj), 7)
              const currentDomain = window.location.hostname
              if (currentDomain === DOMAIN_CONFIG.OVERSEAS_DOMAIN) {
                this.$router.push("/abroad/app/list")
              } else if (currentDomain === DOMAIN_CONFIG.DOMESTIC_DOMAIN) {
                this.$router.push("/app/list")
              }

            }
          }, errmsg => {
            this.$message.error(errmsg)
          })
        } else {
          this.$message.error(this.$t('message.completeForm'))
        }
      })
    },
    getCountryList() {
      this.__getData('getCountryList',null, res => {    
        this.countryList = res.country_info
      })
    },
  }
}
</script>

<style scoped lang="scss">
.wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/img/bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 600px;
}
.headers {
  position: relative;
  height: 100%;
  width: 65%;
  min-width: 800px;
  box-sizing: border-box;
  padding-left: 2%;
  padding-top: 2%;
}
.header-right{
  position: absolute;
  top: 12px;
  right: 60px;
  z-index: 10;
}
::v-deep .el-dropdown {
  cursor: pointer;
}
.header-right .el-dropdown{
  color: rgba(0, 0, 0, 0.85);
}
.headers .logo {
  margin: 26px;
}
.headers .logo img {
  height: 45px;
}
.headers .logo a {
  color: #fff;
  float: left;
  display: flex;
  align-items: flex-end;
}
.logo-text {
  font-size: 20px;
  font-weight: 600;
  color: #0B1D40;
  margin-left: 10px;
  white-space: nowrap;
}
.left_bottom_text_plain {
  position: absolute;
  bottom: 50px;
  left: 54px;
}
.left_bottom_text_plain p {
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}
.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: left;
  font-size: 20px;
  margin-bottom: 20px;
}
.ms-login {
  position: absolute;
  right: 138px;
  top: 50%;
  transform: translateY(-50%);
  width: 494px;
  padding: 30px 47px;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 6px;
}
.submit-button {
  width: 100%;
  font-size: 14px;
  border-radius: 6px;
}
.toLogin {
  text-align: center;
  color: #3361FF;
  cursor: pointer;
}
.user-behavior {
  cursor: pointer;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
}
.devPlatform {
  font-size: 33px;
  font-weight: 700;
}
.title {
  cursor: pointer;
  font-size: 24px;
  font-weight: 700;
  height: 40px;
}
.companyInfo {
  height: 40px;
  font-size: 15px;
  font-weight: 400;
}
.captcha .el-input {
  width: 68%;
  display: inline-block;
}
.ms-content .el-input__inner {
  background: rgba(246, 248, 250, 1);
  line-height: normal;
  font-size: 14px;
  color: rgba(98, 109, 116, 1);
}
.captcha-img {
  height: 40px;
  width: 30%;
  float: right;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
}
.captcha-img img {
  width: 100%;
  height: 40px;
}
.captcha-img:hover .cover {
  z-index: 1;
}
.cover {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: rgba(123, 139, 137, 0.6);
  background-image: url(../../assets/img/captcha-refresh.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
}
::v-deep .el-input-group__prepend {
  background: rgba(147, 165, 186, 1);
  border-radius: 8px 0px 0px 8px;
  color: rgba(255, 255, 255, 1);
}
.ms-content .el-input__inner::-webkit-input-placeholder {
  color: rgba(98, 109, 116, 1);
}
.ms-content .el-input__inner::-moz-placeholder {
  color: rgba(98, 109, 116, 1);
} /* firefox 19+ */
.ms-content .el-input__inner:-ms-input-placeholder {
  color: rgba(98, 109, 116, 1);
} /* Internet Explorer 10+ */
.ms-content .el-input__inner:-moz-placeholder {
  color: rgba(98, 109, 116, 1);
} /* firefox 14-18 */

.send-code-info .el-input {
  width: 68%;
  display: inline-block;
}
.send-code-btn {
  float: right;
  width: 30%;
  height: 40px;
  padding: 0;
}
</style>